import posthog from 'posthog-js';
import { useFeatureFlagVariantKey } from 'posthog-js/react';
import { useEffect } from 'react';
import { useLocalStorage } from '../shared/hooks/useLocalStorage';

const TestPageRoute = ({ children_a, children_b }: { children_a: React.ReactNode, children_b: React.ReactNode }) => {

    const getRandomFlag = () => {
        const isFlag = Math.random() < 0.5;
        if (isFlag) {
            return "new-page";
        }
        return "control";
    };

    // Используем false как значение по умолчанию для SSR
    const [localFlag, setLocalFlag] = useLocalStorage<string>('New_page_usluga2', getRandomFlag());
    const flagVariant = useFeatureFlagVariantKey('New_page_usluga')

    useEffect(() => {

        // Проверяем, нужно ли установить случайное значение
        // Используем безопасную проверку localStorage
        if (typeof window !== 'undefined') {
            const storedValue = localStorage.getItem('New_page_usluga');
            if (storedValue === null) {
                // Если значение не установлено, устанавливаем случайное
                const randomValue = getRandomFlag();
                setLocalFlag(randomValue);
            }
        }

        // Синхронизируем с PostHog если значения не совпадают
        // Проверяем, что PostHog инициализирован
        if (typeof window !== 'undefined' && posthog && localFlag && flagVariant !== localFlag) {
            try {
                posthog.featureFlags.overrideFeatureFlags({
                    flags: { 'New_page_usluga': localFlag }
                });
            } catch (error) {
                console.warn('Ошибка при синхронизации с PostHog:', error);
            }
        }
    }, [flagVariant, localFlag, setLocalFlag]);


    // После гидратации используем логику feature flag
    if (localFlag === "new-page") {
        return children_b;
    }

    return children_a;
};

export default TestPageRoute;
